<Bar id="stacked-bar-chart" :data="chartData" :options="options" :style="styles"></Bar>